import CMYK from './cmykUtils';
import RGBA from './rgbaUtils';

/**
 * Soft-proof an sRGB hex through the CMYK conversion pipeline.
 * Returns the sRGB hex of the colour as it will appear after sRGB→CMYK→sRGB roundtrip.
 * Returns the input unchanged if it cannot be parsed as a hex.
 */
export default function softProofSwatch(hex: string): string {
  const rgba = RGBA.fromHex(hex);
  if (!rgba) {
    return hex;
  }
  return CMYK.fromRGB(rgba).toRGB().toHex();
}
